var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 51,
    viewBox: "0 0 52 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.783 21.08v10.541c0 10.54-3.216 14.757-13.757 14.757h-5.324m2.216-42.162h-10.54C9.838 4.216 5.62 6.432 5.62 16.973v3.162",
    stroke: "#405EDC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.784 21.08H39.35c-6.324 0-8.432-2.107-8.432-8.432V4.216L47.784 21.08z",
    stroke: "#405EDC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zhatlfsw0a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.713 47.466-.556-4.469a5.241 5.241 0 0 1-.85-.419 11.845 11.845 0 0 1-.783-.523L6.39 43.8l-3.822-6.633 3.579-2.724a3.345 3.345 0 0 1-.035-.47v-.943c0-.152.011-.31.035-.472l-3.579-2.723L6.39 23.2l4.134 1.746c.255-.186.52-.361.799-.524a6.99 6.99 0 0 1 .834-.419l.556-4.469h7.642l.556 4.47c.301.116.585.255.852.418.267.163.527.338.78.524l4.135-1.746 3.821 6.634-3.578 2.723c.023.163.035.32.035.472v.941c0 .152-.023.31-.07.472l3.579 2.724-3.822 6.633-4.1-1.745c-.254.186-.52.36-.798.523a6.99 6.99 0 0 1-.834.42l-.556 4.468h-7.643zm3.89-9.077c1.344 0 2.49-.478 3.44-1.432.95-.954 1.424-2.106 1.424-3.456s-.475-2.502-1.424-3.457c-.95-.954-2.096-1.431-3.44-1.431-1.366 0-2.519.477-3.457 1.431-.938.954-1.407 2.107-1.406 3.457 0 1.35.47 2.502 1.407 3.456.938.954 2.09 1.432 3.456 1.432z",
    fill: "#405EDC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "zhatlfsw0a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5 18.5)",
    d: "M0 0h30v30H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settingsIcon.a488ae6c632836d4d43f9fb646a1d91a.svg";
export { ForwardRef as ReactComponent };